module.exports = __webpack_public_path__ + "media/images/lb/480-e4c0e56840fc9bce24603712cf3e16ec.svg";